// extracted by mini-css-extract-plugin
export default {"IndexAdmContent":"IndexAdm_IndexAdmContent__Skljz","contentGraphics":"IndexAdm_contentGraphics__fZM0f","boxGraphics":"IndexAdm_boxGraphics__N6EQ2"};